import { normalizeAuditsToArray } from "../utils/normalize-group-audits.js";
import { hasVisibleAuditChanges } from "./audit-operation-kind.js";

export function filterVisibleAuditGroupsByPermission(groups, canViewSpecial) {
  const normalized = groups.map((group) => ({
    ...group,
    audits: normalizeAuditsToArray(group?.audits),
  }));

  const byPermission = canViewSpecial
    ? normalized
    : normalized.filter((group) => !Boolean(group?.requiresSpecialApproval));

  return byPermission.filter((group) => hasVisibleAuditChanges(group));
}
